module.exports = __webpack_public_path__ + "img/Hero_image.451bfc44.png";